<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="login-bg">
    <div class="logo"></div>
    <div class="login-wrapper">
      <div class="form">
        <div class="username">
          <i class="icon mobile-icon"></i>
          <input title="username" 
                 id="mobile"
                 v-model.trim="mobile"
                 type="text"
                 placeholder="手机号"
                 @blur="validatePhoneNumber"/>
        </div>
        <span class="error" v-if="!isValidPhoneNumber && isBlured">{{ phoneErrorMessage }}</span>
        <div class="pwd">
          <i class="icon pwd-icon"></i>
          <input title="password"
                 id="password"
                 v-model.trim="password"
                 type="password"
                 placeholder="密码"/>
        </div>

        <div class="remember" v-bind:class="{no_remember_me: !isRemember, remember_me:isRemember}"
             v-tap="{methods:handleRememberClick}">

        </div>
      </div>

    </div>
    <div class="login-btn" v-tap="{methods:login}"></div>
  </div>


</template>

<script>
  import { Toast, Indicator } from 'mint-ui';
  import Login from '../api/login';
  import netTool from '../api/netTool';
  import { mapGetters } from 'vuex';
  export default {
    name: 'login',
    created() {
      // 绑定方法到window上
      window.handleCid = this.handleCid;
      if (this.loginInfo) {
        this.mobile = this.loginInfo.mobile;
        this.password = this.loginInfo.password;
      }
    },
    destroy() {
      window.handleCid = undefined;
    },
    deactivated() {
      this.$destroy();
    },
    data () {
      return {
        phoneErrorMessage: '手机号格式不正确', // 错误信息显示文本
        isValidPhoneNumber: true, // 判断手机号是否合法的标志位
        isBlured: false, // 表示输入框失去焦点的状态
        isRemember: true,
        mobile: '',
        password: ''
      };
    },
    methods: {
      validatePhoneNumber(){
        this.isBlured = true; // 设置为true表示已经失去了焦点
        const regExp = /^1[3456789]\d{9}$/; // 手机号的正则表达式
        if (regExp.test(this.mobile)) {
          this.isValidPhoneNumber = true; // 如果符合要求，将标志位设置为true
        } else {
          this.isValidPhoneNumber = false; // 如果不符合要求，将标志位设置为false
        }
      },
      login () {
        if(this.isValidPhoneNumber){
          Indicator.open({
            text: '加载中...',
            spinnerType: 'fading-circle'
          });
          Login.login(this.mobile, this.password).then(response => {
            if (response.code == 500) {
              Toast({
                message: response.msg,
                position: 'middle',
                duration: 3000
              });
            } else {
              this.$store.commit('receivedUserInfoFromRemote', {user: response.result, isStoreLocal: this.isRemember});
              if (this.isRemember) {
                this.$store.commit('saveLoginInfo', {mobile: this.mobile, password: this.password});
              } else {
                this.$store.commit('clearLoginInfo');
              }
              this.getCid();
              if (this.user.roleId === 7) {
                this.$router.push({path: '/parent-main'});
              }else{
                this.$router.push({path: '/teacher-main'});
              }
            }
              // if (response.data==false) {
              //   this.$router.push({path: '/teacher-main'});
              // } else{
              //   this.$router.push({path: '/parent-main'});
              // }


            Indicator.close();
          }).catch(e => {
            Toast({
              message: e.message,
              position: 'middle',
              duration: 3000
            });
            Indicator.close();
          });
        }else{
          Toast({
              message: "手机号格式不正确",
              position: 'middle',
              duration: 3000
            });
        }
      },
      handleMobileChange(text) {
        console.log(text);
      },
      handleRememberClick() {
        this.isRemember = !this.isRemember;
      },
      handleCid(cid) {
        if (!cid || cid === 'null') {
          return;
        }
        netTool.uploadCid({
          user_id: this.$store.state.userInfo.user.user_id,
          clientid: cid,
          client_source_type: this.clientType
        }).then(response => {
          if (response.errno === '0') {
            console.log('cid success post to server!');
          } else {
            console.log('cid success post to server!');
          }
        }).catch(e => {
          console.log(e.message);
        });
      },
      isAndroid() {
        return navigator.userAgent.indexOf('Android') > -1;
      },
      isIOS() {
        return navigator.userAgent.indexOf('iPhone') > -1;
      },
      getCid() {
        if (this.clientType === 10 && window.jsbridge && window.jsbridge.getClientId) {
          window.jsbridge.getClientId();
        } else if (this.clientType === 20 && window.getClientId) {
          window.getClientId();
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUserInfo',
        loginInfo: 'getLoginInfo'
      }),
      clientType() {
        return this.isAndroid() ? 10 : (this.isIOS() ? 20 : 0);
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';
  .error {
    color: red;
    font-size: px2rem(20);
    position: absolute;
  }
  .login-bg {
    /*padding-top: px2rem(215);*/
    width: 100%;
    text-align: center;
    @include bg-img('../assets/img/login_bg');
  }

  .logo {
    display: block;
    margin: px2rem(215) auto 0 auto;
    background: url('../assets/img/logo.png');
    background-size: cover;
    height: px2rem(300);
    width: px2rem(300);
  }

  .login-wrapper {
    margin-top: px2rem(50);
    font-size: px2rem(28);
    .form {
      position: relative;
      width: px2rem(540);
      height: px2rem(270);
      padding: px2rem(54) 0 0 0;
      box-sizing: border-box;
      margin: 0 auto 0 auto;
      @include bg-img('../assets/img/common_bg');

      div {
        height: px2rem(60);
        .icon {
          display: inline-block;
          box-sizing: border-box;
          width: px2rem(42);
          height: px2rem(42);
          margin-top: px2rem(9);
          &.mobile-icon {
            @include bg-img('../assets/img/mobile');
          }
          &.pwd-icon {
            @include bg-img('../assets/img/password');
          }
        }
        input {
          -webkit-appearance: none;
          outline: 0;
          -moz-appearance: none;
          appearance: none;
          vertical-align: top;
          width: px2rem(350);
          height: 100%;
          box-sizing: border-box;
          line-height: px2rem(60);
          padding-left: px2rem(26);
          padding-right: px2rem(26);
          color: white;
          @include bg-img('../assets/img/input_bg');

          &:focus {
            @include bg-img('../assets/img/input_bg');
          }
          &::-webkit-input-placeholder { /* WebKit browsers */
            color: white;
          }
          &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: white;
          }
          &::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: white;
          }
          &:-ms-input-placeholder { /* Internet Explorer 10+ */
            color: white;
          }

        }
      }
      .pwd {
        margin-top: px2rem(33);
      }

      .remember {
        position: absolute;
        width: px2rem(240);
        height: px2rem(70);
        bottom: px2rem(-24);
        left: px2rem(144);
      }
      .remember_me {
        @include bg-img('../assets/img/remember');
      }
      .no_remember_me {
        @include bg-img('../assets/img/no_remember')
      }
    }

  }

  .login-btn {
    display: block;
    height: px2rem(90);
    width: px2rem(280);
    margin: px2rem(86) auto 0 auto;
    @include bg-img('../assets/img/login');
  }


</style>



// WEBPACK FOOTER //
// Login.vue?a898474e